module.exports = __webpack_public_path__ + "assets/center.ada5733b.svg";